import React, { useState, useRef, useEffect } from 'react';
import { useField } from '@rocketseat/unform';
import { useSelector, useDispatch } from 'react-redux';

import { updateAvatarRequest } from '~/store/modules/user/actions';

import api from '~/services/api';

import { Container } from './styles';

export default function AvatarInput() {
  const { defaultValue, registerField } = useField('avatar');

  const [file, setFile] = useState(defaultValue && defaultValue.id);
  const [preview, setPreview] = useState(defaultValue && defaultValue.url);

  const userName = useSelector(state => state.user.profile.name);
  const ref = useRef();

  const dispatch = useDispatch();

  useEffect(() => {
    if (ref.current) {
      registerField({
        name: 'avatar_id',
        ref: ref.current,
        path: 'dataset.file',
      });
    }
  }, [ref.current]); // eslint-disable-line

  async function handleChange(e) {
    const data = new FormData();

    data.append('file', e.target.files[0]);

    const response = await api.post('avatars', data);

    const { id, url } = response.data;

    setFile(id);
    setPreview(url);

    dispatch(
      updateAvatarRequest({
        avatar_id: id,
      })
    );
  }

  return (
    <Container>
      <label htmlFor="avatar">
        <img
          src={
            preview ||
            `https://api.adorable.io/avatars/120/${userName}@adorable.png`
          }
          alt="avatar"
        />
        <div />
        <div>Alterar Imagem</div>
        <input
          type="file"
          id="avatar"
          accept="image/*"
          data-file={file}
          onChange={handleChange}
          ref={ref}
        />
      </label>
    </Container>
  );
}
